import { GROUP_UPDATE, GROUP_REMOVE } from './group.actions';
import { PATIENT_LOGGED_OUT } from '../patient/patient.actions';

const groupReducer = (state = null, action) => {
    switch (action.type) {
        case GROUP_UPDATE:
            return action.value;
        case GROUP_REMOVE:
        case PATIENT_LOGGED_OUT:
            return null;
        default:
            return state;
    }
}

export default groupReducer;